<a
  ecmPushTracker
  [attr.data-e2e]="'e2e-change-offer-btn-' + changeOffer?.code"
  [attr.id-ref-zone]="changeOffer?.idRefZone"
  [pdb-zid]="zid"
  [pdb-sc]="'adv'"
  [pdb-ta]="changeOffer.advTracker"
  [pdb-idc]="changeOffer.code"
  [attr.aria-label]="'Changer votre offre ' + offer.name"
  class="items-list-item dashboard-item-pos"
  (click)="extendedLinkService.openLink(changeOffer.relation); (false)"
  [ecmDisabledAction]="isDisabledEclair"
  [href]="extendedLinkService.getLink(changeOffer.relation)"
>
  <div class="item-container no-border-bottom dashboard-anchor">
    <div class="item-text">
      <span class="lead pt-0">
        <strong>{{ changeOffer.title }}</strong>
      </span>
      <small class="item-desc">{{ changeOffer.content }}</small>
    </div>
  </div>
</a>
